import { render, staticRenderFns } from "./leaf_small.vue?vue&type=template&id=6f3c2fb7&scoped=true&"
import script from "./leaf_small.vue?vue&type=script&lang=js&"
export * from "./leaf_small.vue?vue&type=script&lang=js&"
import style0 from "./leaf_small.vue?vue&type=style&index=0&id=6f3c2fb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3c2fb7",
  null
  
)

export default component.exports